import React, { Component } from 'react';
import {Modal,ModalBody,Button} from 'reactstrap';
import WarningMessage from '../../../../components/Message/WarningMessage/WarningMessage';
import './ToolDetails.css';

class ToolWarningModal extends Component {
  state = {  }

  restoreTool = () => {
    this.props.restoreTool();
    this.props.toggle();
  }

  render() { 
    let {showModal, action} = this.props;
    let title = '';
    let message = '';
    if(action === 'rate') {
      title = 'Add a Rating';
      message = 'You can not rate an archived tool. To rate, first restore the tool by clicking on the button below. The restored tool will be available in its category.';
    } else if (action === 'edit') {
      title = 'Edit Tool';
      message = 'You can not edit an archived tool. To edit, first restore the tool by clicking on the button below. The restored tool will be available in its category.';
    }

    return ( 
      <div>
        <Modal 
          isOpen={showModal}>
          <ModalBody style={{padding:'30px 0px'}}>
            <div className="row">
              <div className="offset-md-1 offset-lg-1 col-sm-10 col-md-10 pick-office-modal-body-title">
              {title}
              </div>
            </div>
            <div className="row mt30">
                <div className="offset-md-1 col-sm-10 col-md-10">
                <WarningMessage iconLeft='' msg="Important Note." subMsg={message} /></div>
            </div>
            <div className="row mt30">
              <div className="offset-md-1 col-sm-3 col-md-3">
                <Button 
                  onClick={this.restoreTool}
                  className="float-right archiveBtn w100"
                >
                  <span className="archiveBtnTxt">Restore Tool</span>
                </Button>
              </div>
              <div className="col-sm-3 col-md-3">
                <Button
                  className="float-left goBackBtn ml10 w100"
                  onClick={this.props.toggle}
                >
                  <span className="goBackBtnTxt">Cancel</span>
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
 
export default ToolWarningModal;